import { render, staticRenderFns } from "./DetailParamInfo.vue?vue&type=template&id=428c812f&scoped=true&"
import script from "./DetailParamInfo.vue?vue&type=script&lang=js&"
export * from "./DetailParamInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailParamInfo.vue?vue&type=style&index=0&id=428c812f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428c812f",
  null
  
)

export default component.exports